import { IAction, IAppState } from '../context/Context'

export namespace Locale {
  export const reducer = (
    prevState: IAppState,
    { locale }: IAction
  ): IAppState => {
    return {
      ...prevState,
      copy: locale?.copy || prevState.copy,
      language: locale?.language || prevState.language,
      loading: false
    }
  }
}